<style type="text/css">
    * {
        margin: 0;
        padding: 0;
        text-indent: 0;
    }
    h1 {
        color: white;
        font-family: Calibri, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
    }
    p {
        color: white;
        font-family: Calibri, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 12pt;
        margin: 0pt;
    }
    .s1 {
        color: #69c6e0;
        font-family: Calibri, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: underline;
        font-size: 12pt;
    }
    .a,
    a {
        color: #69c6e0;
        font-family: Calibri, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: underline;
        font-size: 12pt;
    }
    .s2 {
        color: #69c6e0;
        font-family: Calibri, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: underline;
        font-size: 12pt;
    }
    .s3 {
        color: #69c6e0;
        font-family: Calibri, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
    }
    .s4 {
        color: #69c6e0;
        font-family: Calibri, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
    }
    .s5 {
        color: white;
        font-family: Calibri, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 12pt;
    }
    .s7 {
        color: #69c6e0;
        font-family: Calibri, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 12pt;
    }
    li {
        display: block;
    }
    #l1 {
        padding-left: 0pt;
        counter-reset: c1 1;
    }
    #l1 > li > *:first-child:before {
        counter-increment: c1;
        content: counter(c1, decimal) ". ";
        color: white;
        font-family: Calibri, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
    }
    #l1 > li:first-child > *:first-child:before {
        counter-increment: c1 0;
    }
    #l2 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l2 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c2, lower-latin) ". ";
        color: white;
        font-family: Calibri, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
    }
    #l2 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l3 {
        padding-left: 0pt;
    }
    #l3 > li > *:first-child:before {
        content: " ";
        color: white;
        font-family: Symbol, serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
    }
    #l4 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l4 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c2, lower-latin) ". ";
        color: white;
        font-family: Calibri, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
    }
    #l4 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l5 {
        padding-left: 0pt;
    }
    #l5 > li > *:first-child:before {
        content: " ";
        color: white;
        font-family: Symbol, serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
    }
    #l6 {
        padding-left: 0pt;
    }
    #l6 > li > *:first-child:before {
        content: " ";
        color: white;
        font-family: Symbol, serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
    }
    #l7 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l7 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c2, lower-latin) ". ";
        color: white;
        font-family: Calibri, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
    }
    #l7 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l8 {
        padding-left: 0pt;
    }
    #l8 > li > *:first-child:before {
        content: " ";
        color: white;
        font-family: Symbol, serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
    }
    #l9 {
        padding-left: 0pt;
    }
    #l9 > li > *:first-child:before {
        content: " ";
        color: white;
        font-family: Symbol, serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
    }
</style>
<h1
    style="
        padding-top: 3pt;
        padding-left: 5pt;
        text-indent: 0pt;
        text-align: left;
    "
>
    BeDiCi est en conformité pour le respect de la vie privée.
</h1>
<p style="text-indent: 0pt; text-align: left">
    <br />
</p>
<p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
    Date de mise à jour : Novembre 2024
</p>
<p style="padding-top: 14pt; text-indent: 0pt; text-align: left">
    <br />
</p>
<p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
    La société Occursus est soucieuse des droits des individus, notamment au
    regard des traitements automatisés, et dans une volonté de transparence avec
    ses clients, a mis en place une politique reprenant l’ensemble de ces
    traitements, des finalités poursuivies par ces derniers ainsi que des moyens
    d’action à la disposition des individus afin qu’ils puissent au mieux
    exercer leurs droits. Pour toute information complémentaire sur la
    protection des données personnelles, vous pouvez consulter le site de la
</p>
<p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
    CNIL:
    <a href="http://www.cnil.fr/" class="a" target="_blank"
        >https://www.cnil.fr/</a
    >
</p>
<p style="padding-top: 14pt; text-indent: 0pt; text-align: left">
    <br />
</p>
<p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
    <a
        href="mailto:contact@bedici.com"
        style="
            color: white;
            font-family: Calibri, sans-serif;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            font-size: 12pt;
        "
        target="_blank"
        >Si vous avez la moindre question, surtout n’hésitez pas à nous contact
        via
    </a>
    <a href="mailto:contact@bedici.com" target="_blank"
        >contact&#64;bedici.com</a
    >
</p>
<ol id="l1">
    <li data-list-text="1.">
        <h1
            style="
                padding-top: 14pt;
                padding-left: 18pt;
                text-indent: -12pt;
                text-align: left;
            "
        >
            Responsable du traitement des données à caractère personnel
        </h1>
        <p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
            La société Occursus propriétaire de la marque BeDiCi domiciliée au
            48 rue des Founottes, 25000 Besançon, au capital de 5fff € et
            immatriculée au RCS de Besançon, représentée par Guerric CHALNOT, en
            sa qualité de Président.
        </p>
    </li>
    <li data-list-text="2.">
        <h1
            style="
                padding-left: 18pt;
                text-indent: -12pt;
                line-height: 15pt;
                text-align: left;
            "
        >
            Les finalités de traitement des données à caractère personnel
        </h1>
        <p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
            Les traitements de données à caractère personnel sont mis en œuvre
            pour l’accomplissement des finalités suivantes :
        </p>
        <h1
            style="
                padding-top: 7pt;
                padding-left: 13pt;
                text-indent: 0pt;
                text-align: left;
            "
        >
            Finalité de traitement des données Ǫuels sont les justifications ?
        </h1>
        <p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
            <br />
        </p>
        <p style="padding-left: 17pt; text-indent: 0pt; text-align: left">
            Gestion du compte client et des commandes ;
        </p>
        <p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
            <br />
        </p>
        <p
            style="
                padding-top: 4pt;
                padding-left: 17pt;
                text-indent: 0pt;
                text-align: left;
            "
        >
            Gestion des opérations de paiement ;
        </p>
        <p style="padding-top: 7pt; text-indent: 0pt; text-align: left">
            <br />
        </p>
        <p style="padding-left: 17pt; text-indent: 0pt; text-align: left">
            Gestion de la relation client (téléphone / email), du suivi des
            commandes, du service après- vente et des remboursements ;
        </p>
        <p style="padding-top: 7pt; text-indent: 0pt; text-align: left">
            <br />
        </p>
        <p style="padding-left: 17pt; text-indent: 0pt; text-align: left">
            Opérations de statistiques, d’analyse, de sélection et de
            segmentation des clients afin d’améliorer la connaissance des
            clients ;
        </p>
        <p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
            <br />
        </p>
        <p style="padding-left: 17pt; text-indent: 0pt; text-align: left">
            Exécution du contrat passé sur la base des conditions générales de
            vente
        </p>
        <p style="text-indent: 0pt; text-align: left">
            <br />
        </p>
        <p style="padding-left: 17pt; text-indent: 0pt; text-align: left">
            Intérêt légitime de mieux connaître ses clients
        </p>
        <h1
            style="
                padding-top: 4pt;
                padding-left: 13pt;
                text-indent: 0pt;
                text-align: left;
            "
        >
            Finalité de traitement des données Ǫuels sont les justifications ?
        </h1>
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
            <br />
        </p>
        <p
            style="
                padding-top: 4pt;
                padding-left: 17pt;
                text-indent: 0pt;
                text-align: left;
            "
        >
            Recueil des données de mineurs de moins de 16 ans
        </p>
        <p
            style="
                padding-top: 4pt;
                padding-left: 17pt;
                text-indent: 0pt;
                text-align: left;
            "
        >
            Recueil du consentement du titulaire de l’autorité parentale
        </p>
        <p style="padding-top: 5pt; text-indent: 0pt; text-align: left">
            <br />
        </p>
        <p style="padding-top: 12pt; text-indent: 0pt; text-align: left">
            <br />
        </p>
        <p style="padding-left: 17pt; text-indent: 0pt; text-align: left">
            Transmission de données à des partenaires commerciaux
        </p>
        <p
            style="
                padding-top: 4pt;
                padding-left: 17pt;
                text-indent: 0pt;
                text-align: left;
            "
        >
            Intérêt légitime de Occursus Consentement du Client s’il s’agit de
            données concernant les mineurs de moins de 16 ans ou d’adresses
            emails utilisées à des fins de prospection par le partenaire
        </p>
    </li>
    <li data-list-text="3.">
        <h1
            style="
                padding-top: 11pt;
                padding-left: 18pt;
                text-indent: -12pt;
                text-align: left;
            "
        >
            Les données à caractère personnel collectées par Occursus
        </h1>
        <ol id="l2">
            <li data-list-text="a.">
                <h1
                    style="
                        padding-left: 18pt;
                        text-indent: -12pt;
                        text-align: left;
                    "
                >
                    Origine des données collectées par Occursus
                </h1>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Nous recueillons des informations lorsque vous vous
                    connectez et vous inscrivez dans notre application et sur
                    notre site.
                </p>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Nous sommes susceptibles de collecter des données à
                    caractère personnel auprès de nos sociétés partenaires qui
                    souhaitent faire bénéficier des services de la société
                    Occursus à leur clientèle.
                </p>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Dans l’hypothèse de cette réalisation, la liste des sociétés
                    susceptibles de nous transmettre des données personnelles
                    sera disponible ici.
                </p>
            </li>
            <li data-list-text="b.">
                <h1
                    style="
                        padding-left: 18pt;
                        text-indent: -12pt;
                        line-height: 15pt;
                        text-align: left;
                    "
                >
                    Origine des données collectées par Occursus
                </h1>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Occursus applique les principes de minimisation des données.
                    Nous ne recueillons ainsi que les données utiles à
                    l’exploitation des services que vous choisissez sur BeDiCi.
                    Les données collectées par la société sont les suivantes :
                </p>
                <ul id="l3">
                    <li data-list-text="">
                        <p
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                line-height: 15pt;
                                text-align: left;
                            "
                        >
                            Nom ; prénom ;
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                text-align: left;
                            "
                        >
                            Email
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                text-align: left;
                            "
                        >
                            Prénom de l’enfant et/ou surnom
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                text-align: left;
                            "
                        >
                            Résumé de coordonnées bancaires pour le paiement,
                            non stockées.
                        </p>
                        <p
                            style="
                                padding-top: 14pt;
                                padding-left: 5pt;
                                text-indent: 0pt;
                                text-align: left;
                            "
                        >
                            Dans le cadre de la fourniture du service,
                            <b>les données d’apprentissage </b>
                            seront générées et traitées par la Société. Il
                            s’agit des données suivantes :
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                line-height: 15pt;
                                text-align: left;
                            "
                        >
                            les scores réalisés par l’enfant
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            style="
                                padding-left: 41pt;
                                text-indent: -18pt;
                                text-align: left;
                            "
                        >
                            le parcours d’apprentissage en fonction de ses
                            résultats (Ligues réalisées, modules validés,
                            challenges éventuels, bonus, etc. ).
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                line-height: 15pt;
                                text-align: left;
                            "
                        >
                            Les réponses aux questionnaires de satisfaction.
                        </p>
                        <p style="text-indent: 0pt; text-align: left">
                            <br />
                        </p>
                    </li>
                </ul>
            </li>
        </ol>
    </li>
    <li data-list-text="4.">
        <h1 style="padding-left: 18pt; text-indent: -12pt; text-align: justify">
            Ǫuels sont vos droits ?
        </h1>
        <p style="padding-left: 5pt; text-indent: 0pt; text-align: justify">
            Toute personne physique utilisant le service a la faculté d’exercer
            ses droits d’accès, de rectification, d’opposition et d’effacement
            au traitement de ses données conformément aux articles 38 à 40 de la
            loi du 6 janvier 1978.
        </p>
        <p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
            En application du règlement 2016/679 du 27 avril 2016, la personne
            physique peut exercer son droit à la limitation du traitement, à
            l’effacement de ses données à la portabilité et peut s’opposer au
            profilage à partir du 25 mai 2018.
        </p>
        <p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
            Tout Utilisateur peut également formuler des directives relatives à
            la conservation, à l&#39;effacement et à la communication de ses
            données à caractère personnel après son
        </p>
        <p
            style="
                padding-top: 3pt;
                padding-left: 5pt;
                text-indent: 0pt;
                text-align: left;
            "
        >
            décès conformément à l’article 85 de la loi 78-17 du 6 janvier 1978.
            Ces directives peuvent être générales ou particulières
        </p>
        <ol id="l4">
            <li data-list-text="a.">
                <h1
                    style="
                        padding-left: 18pt;
                        text-indent: -12pt;
                        line-height: 15pt;
                        text-align: left;
                    "
                >
                    Comment les exercer ?
                </h1>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Ces droits peuvent être exercés auprès de la société
                    Occursus qui a collecté les données à caractère personnel de
                    la manière suivante :
                </p>
                <ul id="l5">
                    <li data-list-text="">
                        <p
                            style="
                                padding-left: 41pt;
                                text-indent: -18pt;
                                text-align: left;
                            "
                        >
                            Par voie postale, en nous écrivant à l’adresse
                            suivante : Occursus, 48 rue des Founottes, 25000
                            Besançon.
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                line-height: 15pt;
                                text-align: left;
                            "
                        >
                            <a
                                href="mailto:contact@bedici.com"
                                class="s5"
                                target="_blank"
                            >
                                Par voie électronique à l’adresse
                            </a>
                            <a
                                href="mailto:contact@bedici.com"
                                class="s2"
                                target="_blank"
                            >
                                contact&#64;bedici.com
                            </a>
                        </p>
                        <p style="text-indent: 0pt; text-align: left">
                            <br />
                        </p>
                        <p
                            style="
                                padding-left: 5pt;
                                text-indent: 0pt;
                                text-align: justify;
                            "
                        >
                            Occursus adresse une réponse dans un délai d’1 mois
                            après l’exercice du droit. Dans certains cas, liés à
                            la complexité de la demande ou du nombre de demande,
                            ce délai peut être prolongé de 2 mois.
                        </p>
                    </li>
                </ul>
            </li>
            <li data-list-text="b.">
                <h1
                    style="
                        padding-left: 18pt;
                        text-indent: -12pt;
                        line-height: 15pt;
                        text-align: justify;
                    "
                >
                    Ǫuelles sont les conséquences de l’exercice de certains
                    droits ?
                </h1>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    En cas de l’exercice d’un droit d’opposition au profilage
                    marketing, l’utilisateur est informé qu’il continuera à
                    recevoir des sollicitations commerciales mais celles-ci
                    seront moins pertinentes et ne seront plus ciblées selon ses
                    centres d’intérêts de la personne.
                </p>
            </li>
            <li data-list-text="c.">
                <h1
                    style="
                        padding-left: 18pt;
                        text-indent: -12pt;
                        line-height: 15pt;
                        text-align: left;
                    "
                >
                    Ǫue faire ensuite ?
                </h1>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    En cas de non-réponse ou de réponse non satisfaisante, la
                    personne concernée à la faculté de saisir l’autorité de
                    contrôle compétente, la CNIL à l’adresse
                </p>
                <p style="text-indent: 0pt; text-align: left"></p>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 15pt;
                        text-align: left;
                    "
                >
                    suivante :
                    <a href="http://www.cnil.fr/" class="s4" target="_blank"
                        >https://www.cnil.fr/</a
                    >
                </p>
            </li>
        </ol>
    </li>
    <li data-list-text="5.">
        <h1 style="padding-left: 18pt; text-indent: -12pt; text-align: left">
            La conservation des données
        </h1>
        <p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
            Les données sont conservées pendant une durée qui n’excède pas la
            durée nécessaire aux finalités pour lesquelles elles ont été
            collectées.
        </p>
        <p style="text-indent: 0pt; text-align: left"></p>
        <p
            class="s7"
            style="padding-left: 5pt; text-indent: 0pt; text-align: left"
        >
            <a href="mailto:contact@bedici.com" class="s5" target="_blank">
                Pour la gestion de votre abonnement à la newsletter : nous
                supprimons automatiquement les données au bout de 3 ans
                d’inactivité. En cas de désabonnement, l’envoi des newsletters
                n’est pas automatiquement désactivé. Vous pouvez en faire la
                demande en nous contactant à
            </a>
            contact&#64;bedici.com
            <span style="color: #fff">
                afin de procéder à la suppression effective de votre adresse de
                notre base de données.
            </span>
        </p>
        <p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
            Pour les données recueillies suite à souscription d’un abonnement,
            elles sont conservées pour les besoins de l’exécution de notre
            service, puis nous les supprimons 3 ans après la fin de notre
            relation contractuelle.
        </p>
    </li>
    <li data-list-text="6.">
        <h1
            style="
                padding-left: 18pt;
                text-indent: -12pt;
                line-height: 15pt;
                text-align: left;
            "
        >
            Ǫui sont les destinataires des données ?
        </h1>
        <p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
            Vos données à caractère personnel sont destinées à la société
            Occursus possédant la marque BeDiCi :
        </p>
        <p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
            Vos données sont transmises à des partenaires de Occursus qui
            peuvent traiter les données pour leur compte (ce sont des
            destinataires) ou uniquement pour le compte et selon les
            instructions de Occursus (ce sont des sous-traitants).
        </p>
        <p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
            Les destinataires des données sont :
        </p>
        <ul id="l6">
            <li data-list-text="">
                <p
                    style="
                        padding-left: 41pt;
                        text-indent: -17pt;
                        text-align: left;
                    "
                >
                    Les autorités judiciaires légalement habilitées
                </p>
            </li>
            <li data-list-text="">
                <p
                    style="
                        padding-left: 41pt;
                        text-indent: -18pt;
                        text-align: left;
                    "
                >
                    Les sociétés partenaires commerciales de Occursus dont la
                    liste sera accessible ici, s’il y a des partenariats.
                </p>
            </li>
            <li data-list-text="">
                <p
                    style="
                        padding-left: 41pt;
                        text-indent: -18pt;
                        text-align: left;
                    "
                >
                    Occursus fait également appel à des sous-traitants pour les
                    opérations suivantes :
                </p>
            </li>
            <li data-list-text="">
                <p
                    style="
                        padding-left: 41pt;
                        text-indent: -17pt;
                        line-height: 15pt;
                        text-align: left;
                    "
                >
                    Le paiement sécurisé sur le site
                </p>
            </li>
            <li data-list-text="">
                <p
                    style="
                        padding-left: 41pt;
                        text-indent: -17pt;
                        text-align: left;
                    "
                >
                    L’hébergement des données
                </p>
            </li>
            <li data-list-text="">
                <p
                    style="
                        padding-left: 41pt;
                        text-indent: -18pt;
                        text-align: left;
                    "
                >
                    La réalisation d’opérations de maintenance et de
                    développement techniques du site internet, des applications
                    interne et du système d’information
                </p>
            </li>
            <li data-list-text="">
                <p
                    style="
                        padding-top: 3pt;
                        padding-left: 41pt;
                        text-indent: -17pt;
                        text-align: left;
                    "
                >
                    L’expédition des emails de prospection commerciale
                </p>
            </li>
        </ul>
    </li>
    <li data-list-text="7.">
        <h1 style="padding-left: 18pt; text-indent: -12pt; text-align: left">
            Les données sont-elles envoyées en dehors de l’Union Européenne ?
        </h1>
        <p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
            Pour certaines opérations, des données à caractère personnel peuvent
            être transmises à des sociétés situées dans des pays hors de l’Union
            Européenne. Préalablement au transfert hors Union Européenne, et
            conformément à la règlementation en vigueur, Occursus s’assure de la
            sécurisation de ces transferts de données.
        </p>
        <p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
            Plus d’informations sur les transferts de données en dehors de
            l’Union Européenne peuvent être communiquées sur simple demande
            auprès du délégué à la protection des données.
        </p>
    </li>
    <li data-list-text="8.">
        <h1 style="padding-left: 18pt; text-indent: -12pt; text-align: left">
            Comment ajuster mes préférences en matière de cookies.
        </h1>
        <p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
            Conformément à la directive 2002/58/CE du 12 juillet 2002, la
            société Occursus peut recueillir votre consentement préalable au
            dépôt des cookies publicitaires, de mesure d’audience et de partage
            vers les réseaux sociaux.
        </p>
        <p style="padding-left: 5pt; text-indent: 0pt; text-align: left">
            Vous pouvez faire le choix à tout moment d&#39;exprimer et de
            modifier vos souhaits en matière de cookies, par les moyens décrits
            ci-dessous.
        </p>
        <ol id="l7">
            <li data-list-text="a.">
                <h1
                    style="
                        padding-left: 18pt;
                        text-indent: -12pt;
                        line-height: 15pt;
                        text-align: left;
                    "
                >
                    Paramétrage de votre logiciel de navigation
                </h1>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Vous pouvez configurer votre logiciel de navigation de
                    manière à ce que des cookies soient enregistrés dans votre
                    terminal ou, au contraire, qu&#39;ils soient rejetés, soit
                    systématiquement, soit selon leur émetteur. Vous pouvez
                    également configurer votre logiciel de navigation de manière
                    à ce que l&#39;acceptation ou le refus des cookies vous
                    soient proposés ponctuellement, avant qu&#39;un cookie soit
                    susceptible d&#39;être enregistré dans votre terminal.
                </p>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 15pt;
                        text-align: left;
                    "
                >
                    Comment exercer vos choix, selon le navigateur que vous
                    utilisez ?
                </p>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Pour la gestion des cookies et de vos choix, la
                    configuration de chaque navigateur est différente. Elle est
                    décrite dans le menu d&#39;aide de votre navigateur, qui
                    vous permettra de savoir de quelle manière modifier vos
                    souhaits en matière de cookies.
                </p>
                <ul id="l8">
                    <li data-list-text="">
                        <p
                            class="s1"
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                line-height: 15pt;
                                text-align: left;
                            "
                        >
                            Pour Internet Explorer™
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            class="s1"
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                text-align: left;
                            "
                        >
                            Pour Safari™
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            class="s1"
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                text-align: left;
                            "
                        >
                            Pour Chrome™
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            class="s1"
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                text-align: left;
                            "
                        >
                            Pour Firefox™
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            class="s1"
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                text-align: left;
                            "
                        >
                            Pour Opera™
                        </p>
                    </li>
                </ul>
            </li>
            <li data-list-text="b.">
                <h1
                    style="
                        padding-left: 18pt;
                        text-indent: -12pt;
                        text-align: left;
                    "
                >
                    Paramétrage des cookies avec un outil proposé par Occursus
                </h1>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Afin de se conformer à la règlementation et cas besoin
                    fonction des données collectées, Occursus pourra utiliser un
                    outil permettant à l’internaute de paramétrer le dépôt des
                    cookies lors de sa connexion sur le site ou sur
                    l’application mobile. Un lien sera alors disponible ici pour
                    accéder à la liste des cookies déposés et pouvoir en
                    configurer le dépôt.
                </p>
            </li>
            <li data-list-text="c.">
                <h1
                    style="
                        padding-left: 18pt;
                        text-indent: -12pt;
                        text-align: left;
                    "
                >
                    Liste d’opposition permettant de gérer le dépôt des cookies
                </h1>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Vous avez également la possibilité de vous opposer au dépôt
                    des cookies en accédant au site internet
                    <a
                        href="http://www.youronlinechoices.com/fr/controler-ses-cookies/"
                        class="a"
                        target="_blank"
                        >https://</a
                    ><span class="s1"
                        >www.youronlinechoices.com/fr/controler-ses-cookies/</span
                    ><span class="s3"> </span>.
                </p>
            </li>
            <li data-list-text="d.">
                <h1
                    style="
                        padding-left: 18pt;
                        text-indent: -13pt;
                        line-height: 15pt;
                        text-align: left;
                    "
                >
                    Lien des éditeurs tiers
                </h1>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Occursus utilise des cookies de partage vers les réseaux
                    sociaux dont l’internaute peut consulter la politique de
                    protection des données pour paramétrer les cookies :
                </p>
                <ul id="l9">
                    <li data-list-text="">
                        <p
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                line-height: 15pt;
                                text-align: left;
                            "
                        >
                            Facebook :
                            <span class="s1"
                                >politique d’utilisation des données</span
                            >
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                text-align: left;
                            "
                        >
                            Instagram :
                            <span class="s1"
                                >politique d’utilisation des données</span
                            >
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                text-align: left;
                            "
                        >
                            Et potentiellement d’autres réseaux faisant que
                            cette liste est non exhaustive.
                        </p>
                    </li>
                </ul>
            </li>
        </ol>
    </li>
</ol>
<p
    style="
        padding-top: 3pt;
        padding-left: 5pt;
        text-indent: 0pt;
        text-align: left;
    "
>
    Occursus pourra être amené à utiliser le cookie de mesure d’audience Google
    Analytics pouvant être paramétré à l’adresse
</p>
<p
    style="
        padding-left: 5pt;
        text-indent: 0pt;
        line-height: 15pt;
        text-align: left;
    "
>
    suivante :
    <span class="s1">https://tools.google.com/dlpage/gaoptout?hl=fr</span>.
</p>
<h1 style="padding-left: 5pt; text-indent: 0pt; text-align: left">
    G. Comment contacter le délégué à la protection des données ?
</h1>
<p class="s7" style="padding-left: 5pt; text-indent: 0pt; text-align: left">
    <a href="mailto:contact@bedici.com" class="s5" target="_blank"
        >Occursus a désigné un délégué à la protection des données pouvant être
        contacté à l’adresse </a
    ><span
        style="
            color: #69c6e0;
            font-family: Calibri, sans-serif;
            font-style: normal;
            font-weight: normal;
            text-decoration: underline;
            font-size: 12pt;
        "
        >contact&#64;bedici.com</span
    >
    <span style="color: #fff"
        >avec l’indication du délégué à la protection des données de BeDiCi
        comme destinataire.</span
    >
</p>
